import { HFlow, Text } from 'bold-ui'
import { SelectField, SelectFieldProps } from 'components/form'
import { useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { ImunobiologicoComboDocument } from 'graphql/hooks.generated'
import { ImunobiologicoComboQuery, ImunobiologicoComboQueryVariables } from 'graphql/types.generated'
import React from 'react'

export type ImunobiologicoSelectModel = ImunobiologicoComboQuery['imunobiologicos']['content'][0]

export interface ImunobiologicoSelectFieldProps
  extends Omit<SelectFieldProps<ImunobiologicoSelectModel>, 'items' | 'itemToString'> {}

export function ImunobiologicoSelectField(props: ImunobiologicoSelectFieldProps) {
  const { ...rest } = props

  const asyncProps = useAsyncQuerySelect<
    ImunobiologicoSelectModel,
    ImunobiologicoComboQuery,
    ImunobiologicoComboQueryVariables
  >({
    query: ImunobiologicoComboDocument,
    extractItems: (data) => data?.imunobiologicos?.content,
    variables: (inputQuery: string) => ({
      input: {
        query: inputQuery,
        pageParams: {
          size: 10,
        },
      },
    }),
  })

  const itemToString = (item: ImunobiologicoSelectModel) => (item ? `${item.sigla} - ${item.nome}` : undefined)

  const renderItem = (item: ImunobiologicoSelectModel) => (
    <>
      <Text fontWeight='bold'>{item.sigla}</Text>
      <HFlow hSpacing={0.5}>
        <Text> {item.nome}</Text>
      </HFlow>
    </>
  )

  return (
    <SelectField<ImunobiologicoSelectModel>
      itemToString={itemToString}
      renderItem={renderItem}
      {...asyncProps}
      {...rest}
    />
  )
}
